import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useSaasPlans() {
  return useQuery({
    queryKey: ["saas", "plans"],
    queryFn: () => apiClient.get("/api/v1/saas/plans/").then((r) => r.data),
    staleTime: 10 * 60 * 1000,
  });
}

export { useSaasPlans };
